// @format

import 'jquery'
import 'jquery-drawer'
import 'jquery-drawer/dist/css/drawer.css';

declare global {
  interface JQuery {
    drawer(): JQuery
  }
}
export function initBotsProspectReplyModal(): void {
  $(document).on('click', '.view-full-data', function() {
    const content = $(this).data('content')
    const title = $(this).data('title')
    const modal = $('#replyModal')
    if (title == 'Full Current Company' || title == 'Full Campaign Name') {
      modal.find(`[data-modal-target="content"]`).html(content)
    } else {
      modal.find(`[data-modal-target="content"]`).text(content)
    }
    modal.find(`[data-modal-target="title"]`).text(title)

    modal.modal('show')
  })
}

export function initBotsProspectProfileModal() {
  const $drawer = $('#profile-drawer');
  const $fullProfileDrawer = $('#full-profile-drawer');

  if (!$drawer.length || !$fullProfileDrawer.length) return;

  function openDrawer(drawerId: string, drawerOverlayId: string) {
    $(`#${drawerId}`).addClass('active');
    $(`#${drawerOverlayId}`).addClass('active');
  }

  function closeDrawer(drawerId: string, drawerOverlayId: string) {
    $(`#${drawerId}`).removeClass('active');
    $(`#${drawerOverlayId}`).removeClass('active');
  }

  function populateProfileDrawer(data: any) {
    $drawer.find('#prospectName').text(data.name || '');
    $drawer.find('#prospectLocation').text(data.location || '');
  }

  function populateFullProfileDrawer(data: any) {
    $fullProfileDrawer.find('#prospectName').text(data.name || '');
    if (data.companyDomain !== "N/A") {
      $fullProfileDrawer.find('#prospectCompany').html(`
        <a
          href="https://${data.companyDomain}"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary"
          style="text-decoration: none;"
        >
          ${data.companyName}
        </a>
      `)
    } else {
      $fullProfileDrawer.find('#prospectCompany').text(data.company || '');
    }

    $fullProfileDrawer.find('#prospectPosition').text(data.position || '');
    $fullProfileDrawer.find('#prospectDomain').text(data.domain || '');
  }

  // $(document).on('click', '.view-full-profile', function() {
  //   try {
  //     const prospect = $(this).closest('td').data('prospect');
  //     populateProfileDrawer(prospect);
  //     openDrawer('profile-drawer', 'profile-drawer-overlay');
  //     $drawer.find('#open-full-drawer-btn').on('click', () => {
  //       try {
  //         const btn = $(this);
  //         const prospect = btn.closest('td').data('prospect');
  //         populateFullProfileDrawer(prospect);
  //         openDrawer('full-profile-drawer', 'full-profile-drawer-overlay');
  //       } catch (err) {
  //         alert("Something went wrong, cannot load data for this candidate");
  //       }
  //     });
  //   } catch (err) {
  //     alert("Something went wrong, cannot load data for this candidate");
  //   }
  // });

  $drawer.find('.drawer-close').on('click', function() {
    closeDrawer('profile-drawer', 'profile-drawer-overlay');
  });

  $('#profile-drawer-overlay').on('click', function() {
    closeDrawer('profile-drawer', 'profile-drawer-overlay');
  });

  $fullProfileDrawer.find('.drawer-close').on('click', function() {
    closeDrawer('full-profile-drawer', 'full-profile-drawer-overlay');
  });

  $('#full-profile-drawer-overlay').on('click', function() {
    closeDrawer('full-profile-drawer', 'full-profile-drawer-overlay');
  });
}

export function initPaginationLimitButtons(): void {
  $(document).ready(function() {
    const $buttons = $('.pagination-limit-btn')
    const activeColor = '#005cd3'

    const initialLimit = 100

    $buttons.each(function() {
      const $button = $(this)
      const limit = parseInt($button.data('limit'), 10)

      if (limit === initialLimit) {
        $button.css('background-color', activeColor)
        $button.css('color', '#fff')
      } else {
        $button.css('background-color', '')
        $button.css('color', '')
      }
    })

    $buttons.on('click', function() {
      const $clicked = $(this)
      const limit = parseInt($clicked.data('limit'), 10)

      $buttons.css({ 'background-color': '', 'color': '' })
      $clicked.css({ 'background-color': activeColor, 'color': '#fff' })

      const globalWindow = window as typeof window & {
        changePaginationLimit?: (limit: number) => void
      }

      if (typeof globalWindow.changePaginationLimit === 'function') {
        globalWindow.changePaginationLimit(limit)
      }
    })
  })
}

export function initCandidateDashboardSearchInput() {
	const $searchInput = $('#search-input');
	const $hiddenQueryInput = $('input[name="query"]');
	const $form = $('.bots-prospects-form');

	$searchInput.on('keyup', function(e) {
		if (e.key === 'Enter') {
			$hiddenQueryInput.val($searchInput.val());
			$form.submit();
		}
	});
}